<template>
    <div class="pdf-viewer-container">
        <div class="pdf-header">
            <div class="pdf-title">{{ title }}</div>
            <div class="pdf-actions">
                <a :href="pdfUrl" target="_blank" class="download-btn">
                    <i class="fas fa-download"></i> Download PDF
                </a>
                <button @click="$emit('close')" class="close-btn">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        </div>
        <div class="pdf-content">
            <iframe 
                :src="pdfUrl" 
                width="100%" 
                height="100%" 
                frameborder="0"
                style="border: none;">
                <p>Your browser does not support PDFs. 
                   <a :href="pdfUrl" target="_blank">Download the PDF</a>.
                </p>
            </iframe>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PdfViewer',
    props: {
        pdfUrl: {
            type: String,
            required: true
        },
        title: {
            type: String,
            default: 'PDF Document'
        }
    },
    emits: ['close']
}
</script>

<style scoped>
.pdf-viewer-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: white;
    z-index: 9999;
    display: flex;
    flex-direction: column;
}

.pdf-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    background: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.pdf-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
}

.pdf-actions {
    display: flex;
    align-items: center;
    gap: 10px;
}

.download-btn, .close-btn {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: all 0.2s ease;
}

.download-btn {
    background: #007bff;
    color: white;
}

.download-btn:hover {
    background: #0056b3;
    color: white;
    text-decoration: none;
}

.close-btn {
    background: #6c757d;
    color: white;
}

.close-btn:hover {
    background: #545b62;
}

.pdf-content {
    flex: 1;
    width: 100%;
    height: calc(100vh - 70px);
}

@media (max-width: 768px) {
    .pdf-header {
        padding: 10px 15px;
    }
    
    .pdf-title {
        font-size: 16px;
    }
    
    .download-btn, .close-btn {
        padding: 6px 12px;
        font-size: 12px;
    }
}
</style>